import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\DashboardController::__invoke
* @see app/Http/Controllers/Investors/DashboardController.php:31
* @route '//app.finesthub.de/dashboard'
*/
const DashboardController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: DashboardController.url(options),
    method: 'get',
})

DashboardController.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\DashboardController::__invoke
* @see app/Http/Controllers/Investors/DashboardController.php:31
* @route '//app.finesthub.de/dashboard'
*/
DashboardController.url = (options?: RouteQueryOptions) => {
    return DashboardController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\DashboardController::__invoke
* @see app/Http/Controllers/Investors/DashboardController.php:31
* @route '//app.finesthub.de/dashboard'
*/
DashboardController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: DashboardController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\DashboardController::__invoke
* @see app/Http/Controllers/Investors/DashboardController.php:31
* @route '//app.finesthub.de/dashboard'
*/
DashboardController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: DashboardController.url(options),
    method: 'head',
})

export default DashboardController